import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const OurServices = () => {

    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <section>
                <div className="inn-body-section">
                    <div className="container">
                        <div className="page-head">
                            <h2 style={{ 'fontSize': '33px' }}>Our Services</h2>
                            <div className="head-title">
                                <div className="hl-1"></div>
                                <div className="hl-2"></div>
                                <div className="hl-3"></div>
                            </div>
                            <p>Younic Home offers safe, comfortable, and community-focused living — perfect for students, professionals, and women.</p>
                        </div>

                        <div className="content-section">
                            <section class="content-section container mt-5">
                                <div class="row">
                                    <div class="col-md-12">
                                    <strong>Comfortable Bunk Bed Accommodation</strong>
                                    <p className='mt-2'>Our signature bunk bed system offers both space-saving design and affordable daily rates, starting from just $2.99/day. With stair-type access and secure storage, it’s practical, private, and perfect for modern urban living.</p>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>24/7 Security & CCTV Surveillance</strong>
                                            <p className='mt-2'>Your safety is our top priority. All Younic Home branches are equipped with round-the-clock CCTV monitoring, trained security staff, and controlled access points to ensure peace of mind.</p>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Generator Backup</strong>
                                            <p className='mt-2'>No more power cuts! All our facilities come with 24/7 generator support so you can enjoy uninterrupted electricity for lights, fans, WiFi, and your daily essentials.</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Daily Housekeeping</strong>
                                            <p className='mt-2'>We maintain a clean and hygienic environment with our daily housekeeping service. Our trained staff ensures common areas and personal spaces are regularly cleaned and well-managed.</p>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>High-Speed Internet</strong>
                                            <p className='mt-2'>Stay connected with reliable high-speed WiFi in all branches — perfect for students attending online classes or professionals working remotely.</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Laundry Support</strong>
                                            <p className='mt-2'>In selected branches, we provide laundry assistance or access to self-service laundry facilities — so you can focus on living, not washing.</p>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Secure Storage</strong>
                                            <p className='mt-2'>Each resident gets dedicated locker or personal storage space to keep their belongings safe and organized.</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Special Care Package – Care & Comfort for Mothers</strong>
                                            <p className='mt-2'>Available at our Uttara Female Branch, this unique package supports pregnant women and new mothers with a nurturing environment, emotional support, and health-conscious services.</p>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Women-Only Facilities</strong>
                                            <p className='mt-2'>With dedicated female-only branches, we provide a secure, respectful, and empowering space for women to live confidently and comfortably.</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Centralized Supply Chain</strong>
                                            <p className='mt-2'>We manage our branches efficiently through a centralized supply chain system, ensuring residents get uninterrupted access to essential goods and services.</p>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Digital Complaint & Support System</strong>
                                            <p className='mt-2'>Our 30 lakh taka CRM investment allows us to manage complaints, requests, and maintenance through a smart system — ensuring quick responses and transparent communication.</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="service-card">
                                            <strong>Flexible Stay Options</strong>
                                            <p className='mt-2'>Choose what fits you best:</p>
                                            <ul class="list-group list-group-flush">
                                                <li class="list-group-item">● Daily Stay</li>
                                                <li class="list-group-item">● Weekly/Monthly Packages</li>
                                                <li class="list-group-item">● Long-Term Residency</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default OurServices;
